// src/components/TermsAndConditions.jsx (Stub for Workflow)
import React from 'react';
import {  useNavigate } from 'react-router-dom';

function Welcome() {
  // Initialize state for each checkbox.
  // 'initialData' here might be a boolean if only T&C acceptance was stored previously,
  // or an object if individual consents were stored. Adjust accordingly.
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-full">
      <h3 className="text-lg font-semibold text-primary mb-4">Welcome Aboard!</h3>
      <p className="mb-6 text-sm text-neutral-dark">
        Your registration is complete — we're excited to have you with us!
        From here, you can go straight to your dashboard to explore your account, or book your first appointment to get started right away.
      </p>
      <div className="space-y-5 flex-grow"> {/* Increased spacing */}
        <div className="flex justify-around items-center gap-4">
            <button
                type="button"
                onClick={() => navigate('/dashboard')}
                className="w-1/2 md:w-1/3 bg-button text-white py-2 rounded-md hover:bg-button-light transition duration-200"
            >
                Go to Dashboard
            </button>
            <button
                type="button"
                onClick={() => navigate('/schedule')}
                className="w-1/2 md:w-1/3 bg-button text-white py-2 rounded-md hover:bg-button-light transition duration-200"
            >
                Make an Appointment
            </button>
        </div>
      </div>

      {/* The parent RegistrationWorkflow provides the "Previous" button */}
    </div>
  );
}

export default Welcome;
